import axios from "axios";
export default axios.create({
  baseURL: "https://api.superstudyparty.com/api",
  headers: {
    "Content-type": "application/json",
  },
});
